import { Directive, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms'
@Directive({
  selector: '[connectForm]'
})
export class ConnectFormDirective {
  @Input('connectForm')
  set data(val: any) {
    if (val) {
      // NOTE there may come a point where we do need to emitEvent: true
      // for the form when the state change. I feel false is the more typical case
      // in order to avoid having to filter it on the component level.
      // If we do need it, we should probably create a new directive
      this.formGroupDirective.form.patchValue(val, { emitEvent: false });
      this.formGroupDirective.form.markAsPristine();
    }
  }
  constructor(private formGroupDirective: FormGroupDirective) { }

}
